export const ONLY_ALLOWED_ONE = [
    'Right Master Box',
    'Left Master Box',
    'Cab Master Box',
    'DL-18',
    'CTH-518',
    'SC-12 LEFT MASTER',
    'SC-12 RIGHT MASTER',
    'SC-12 CAB MASTER',
    'A SC-12 RETROCORE',
    'A SC-12 CORE HUB',
    'SC-12 LINE PILOT XP',
    'SC-12 CORE HUB',
    'SC-12 RETROCORE',
];

export const MUTUALLY_EXCLUSIVE = [
    'MST-14',
    'Core Hub',
    'Retrocore'
];

// Core Hub / Retrocore / Core Skipper pins with hard-coded electrical functions
// (grounds, sensor power, motion sensor input). These must never be editable —
// by hand or by pinout import. Matching is by name token so catalog variants
// (SC-12 CORE HUB) and imported names are covered. The backend enforces the
// same set in app/core/truckorderform.py.
export const CORE_FIXED_PINS = ['A', 'B', 'E', 'F', 'G', 'J'];
export const CORE_ITEM_TOKENS = ['CORE HUB', 'RETROCORE', 'CORE SKIPPER'];

export const isFixedCorePin = (itemName, inputOutput) => {
    const name = (itemName || '').toUpperCase();
    return CORE_ITEM_TOKENS.some(token => name.includes(token))
        && CORE_FIXED_PINS.includes(inputOutput);
};

// Library categories, in display order. Analog sits above digital to match the
// wiring-sheet layout engineers read the truck from.
export const HARDWARE_CATEGORY_ORDER = [
    'Control Modules',
    'Analog I/O',
    'H-Bridge I/O',
    'Digital I/O',
    'Temperature',
    'Data Logging & Display',
    'Other',
];

export const categorizeHardwareItem = (itemName) => {
    const name = (itemName || '').toUpperCase();
    if (
        name.includes('MASTER') || name.includes('CORE HUB') || name.includes('RETROCORE')
        || name.includes('MST-14') || name.includes('LINE PILOT') || name.includes('SWITCH BOX')
    ) return 'Control Modules';
    if (name.includes('CANLG-TC')) return 'Temperature';
    if (name.includes('CANLG-IN') || name.includes('CANLG-OUT')) return 'Analog I/O';
    if (name.includes('HB')) return 'H-Bridge I/O';
    if (name.includes('CDRV') || name.includes('COPTO')) return 'Digital I/O';
    if (
        name.includes('DL-18') || name.includes('HDVO') || name.includes('MONITOR')
        || name.includes('PRINTER') || name.includes('SPEEDO') || name.includes('CTH-518')
    ) return 'Data Logging & Display';
    return 'Other';
};

// "DL18" should find "DL-18": ignore dashes and whitespace when matching
export const normalizeForSearch = (text) =>
    (text || '').toLowerCase().replace(/[-\s]/g, '');

// Groups where only one item from the group can be selected
// If any item with a group identifier is selected, all other items with that identifier are filtered out
// Master boxes are deliberately NOT grouped: a real truck carries one master box
// per type (left, right, cab simultaneously), so per-type uniqueness comes from
// ONLY_ALLOWED_ONE instead.
export const EXCLUSIVE_GROUPS = {
    'SC-12': [
        'A SC-12 RETROCORE',
        'A SC-12 CORE HUB',
        'SC-12 LINE PILOT XP',
        'SC-12 CORE HUB',
        'SC-12 RETROCORE',
    ],
};

// Truck type mappings
export const TRUCK_TYPES = {
    THERMOPLASTIC: 'Thermoplastic',
    EPOXY: 'Epoxy',
    GRINDER: 'Grinder',
    MMA: 'MMA',
    PAINT: 'Paint',
    MRL_GRINDER: 'MRL Grinder',
};

// Hardware items restricted by truck type
export const TRUCK_TYPE_RESTRICTIONS = {
    // 'Proprietary Bag Feeder Option': [TRUCK_TYPES.THERMOPLASTIC],
    // 'Density Based Paint Usage Rates': [TRUCK_TYPES.THERMOPLASTIC],
    // 'Custom MMA System': [TRUCK_TYPES.MMA],
    // 'Epoxy Bi-Directional Pump Control': [TRUCK_TYPES.EPOXY],
    // 'Epoxy Catalyst/Resin Ratio Monitoring': [TRUCK_TYPES.EPOXY],
    // 'Grind Head Depth Control': [TRUCK_TYPES.GRINDER],
    // 'Marker One Grinder Cut Profile': [TRUCK_TYPES.GRINDER],
    // 'Pressure Control': [TRUCK_TYPES.GRINDER],
    // 'Reflective Marker Layout': [TRUCK_TYPES.PAINT],
    // 'Pump Boost': [TRUCK_TYPES.PAINT],
    // 'Wireless Remote': [TRUCK_TYPES.MRL_GRINDER],
};

// Hardware item dependencies - items that require other items to function
export const HARDWARE_DEPENDENCIES = {
    'Temperature Control Feature': 'HDVO-318',
    'CTH-518': 'DL-18',
    'SC-12 LINE PILOT XP': 'DL-18,HDVO-318', //and hdvo
    'CSTAX-VIN8': 'DL-18',
    'ACCU-BEAD Sensor': 'DL-18,CSTAX-VIN8',
    'STINGRAY 2 Laser': 'DL-18',
    'STINGRAY 3 Laser': 'DL-18',
};
